export default __webpack_public_path__ + "static/media/avatar.86b42d1a.svg";